module.exports = __webpack_public_path__ + "img/Speaker=Amjad Masad.4d2eac79.png";